import React  from 'react';
import PropTypes from 'prop-types';
import { styles } from './styles';

const CourseListItem = ({course, pos, removeCourseByPos, t}) => {
  return (
    <div style={{display:'inline-block', marginRight:5, fontSize:'13px', color:'black'}}>
      <table style={{backgroundColor: '#F0F0F0',
                marginBottom:2,borderRadius:7}}>
        <tbody>
        <tr>
          <td style={{padding:5, paddingLeft:20, paddingRight:12, verticalAlign:'middle', textAlign:'center'}} className={'course-list-item-name'}>
            {course.name}
          </td>
          <td style={{padding:5, verticalAlign:'middle', textAlign:'right'}} >
            <a style={{cursor:'pointer'}}
               onClick={() => removeCourseByPos(pos, course.cpid)}
               title={t('Remove course')}
               className={'course-list-item-remove'}>
              X
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  );
};

export const AddedCourseList = ({courses, removeCourseByPos, t}) => {
  const renderedCourses = (courses || []).map((course, i) => {
    return (
      <CourseListItem
        key={'course_'+i}
        course={course}
        pos={i}
        removeCourseByPos={removeCourseByPos}
        t={t}
      />
    );
  });

  const noCourses = (courses || []).length === 0;

  return (
    <div style={{maxWidth:600}}>
      <div style={{...styles.courseHeading, marginTop:35, marginBottom:15}}>
        {t('Select Courses')}
      </div>
      {
        noCourses &&
        <div style={{height:28, fontSize:'13px', color:'grey', fontStyle:'italic'}} id={'no-course-selected'}>
          {t('No courses selected')}
        </div>
      }
      {renderedCourses}
    </div>
  );
};

AddedCourseList.propTypes = {
  courses: PropTypes.array.isRequired,
  removeCourseByPos: PropTypes.func.isRequired
};



/** WEBPACK FOOTER **
 ** ./components/race/create/AddedCourseList.js
 **/